import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle({ className = "", variant = "icon" }) {
    const { theme, toggleTheme } = useTheme();
    const isLight = theme === "light";
    if (variant === "menu") {
        return (
            <button
                type="button"
                data-testid="theme-toggle-menu"
                onClick={toggleTheme}
                className={`w-full flex items-center gap-2 px-3 py-2.5 border-t border-[#2a2a2a] text-sm text-[#e5e5e5] hover:bg-[#0f0f0f] hover:text-[#ff4500] transition-colors ${className}`}
            >
                {isLight ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
                <span>{isLight ? "Dark mode" : "Light mode"}</span>
            </button>
        );
    }
    return (
        <button
            type="button"
            data-testid="theme-toggle"
            onClick={toggleTheme}
            title={isLight ? "Switch to dark theme" : "Switch to light theme"}
            aria-label="Toggle color theme"
            className={`inline-flex items-center justify-center h-9 w-9 rounded-full border border-[#2a2a2a] bg-[#141414] text-[#a0a0a0] hover:text-[#ff4500] hover:border-[#ff4500] transition-colors ${className}`}
        >
            {isLight ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
        </button>
    );
}
